import type * as React from 'react';

import { Utilities } from '../../../MedicareProAPI/Utilities/Utilities';
import { Form } from 'react-bootstrap';
import dateFormat from 'dateformat';

export interface SoaFormProps {
  onChange: ({}) => void;
  formData: any;
}
/**
 * Component filling out an SOA
 *
 * @author Andrew Brown <abrown@medicareprocrm.com>
 */
export const SoaForm = (props: SoaFormProps): React.JSX.Element => {
  const methodOfContact = ['Phone', 'Email', 'Text', 'Mail', 'In-person', 'Walk-in', 'Other'];
  const planDiscussed = [
    { value: 'MAPD', label: 'MAPD & Cost Plans' },
    { value: 'PDP', label: "PDP's" },
    { value: 'SUP', label: 'Medicare Supplements' },
    { value: 'DVH', label: 'Dental-Vision-Hearing Products' },
    { value: 'ANC', label: 'Hospital Indemnity Products' },
  ];

  return (
    <>
      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold mb-2 boldHeaderLabel">
          What you want to discuss
        </div>

        {planDiscussed.map((discuss) => {
          return (
            <>
              <div className="col-6">
                <input
                  type="checkbox"
                  value={discuss.value}
                  checked={props.formData.soaDiscussionCheck.includes(discuss.value)}
                  onChange={props.onChange}
                  name="soaDiscussionCheck"
                />
                <span className="ml-2">{discuss.label}</span>
              </div>
            </>
          );
        })}
      </div>
      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold border-top border-info mt-3 mb-2 boldHeaderLabel">
          Beneficiary Information
        </div>

        <div className="col-12 col-lg-7 mb-2">
          <label className="label">Beneficiary Name</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaBeneficiaryName"
            value={props.formData.soaBeneficiaryName}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaBeneficiaryName && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
        <div className="col-12 col-lg-5 mb-2">
          <label className="label">Beneficiary Phone</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaBeneficiaryPhone"
            value={props.formData.soaBeneficiaryPhone}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaBeneficiaryPhone && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
        <div className="col-12  mb-2">
          <label className="label">Beneficiary Address</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaBeneficiaryAddress"
            value={props.formData.soaBeneficiaryAddress}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaBeneficiaryAddress && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
      </div>
      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold border-top border-info mt-3 mb-2 boldHeaderLabel">
          Agent Information
        </div>

        <div className="col-12 col-lg-4 mb-2">
          <label className="label">Agent Name</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaAgentName"
            value={props.formData.soaAgentName}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaAgentName && <small className="text-danger">Field is required</small>}
        </div>
        <div className="col-12 col-lg-4 mb-2">
          <label className="label">Agent Phone</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaAgentPhone"
            value={props.formData.soaAgentPhone}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaAgentPhone && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
        <div className="col-12 col-lg-4 mb-2">
          <label className="label">Agent NPN</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaAgentNpn"
            value={props.formData.soaAgentNpn}
            onChange={props.onChange}
          />
        </div>
        <div className="col-12">
          <div className="alert alert-info p-1" style={{ fontSize: '9pt' }}>
            <i className="far fa-info-circle mr-1"></i>You will sign the document once its been
            completed by the beneficiary. Your dashboard will list documents that need your
            attention. Click{' '}
            <a href="https://www.medicareproapp.com/agent/settings/index/notifications">here</a> to
            configure notifications.
          </div>
        </div>
        {/*
                <div className="col-12  mb-2">
                    <label  className="label">Agent Signature</label>
                    <input type="text" style={{fontSize: "12pt"}} className="form-control border border-warning keep" name="soaAgentSignature" id="soaAgentSignature" value={props.formData.soaAgentSignature} onChange={props.onChange} required/> 
                </div>
                */}
      </div>

      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold border-top border-info mt-3 mb-2 boldHeaderLabel">
          Appointment Details
        </div>

        <div className="col-12 col-lg-8 mb-2">
          <label className="label">Initial Contact Method</label>
          <select
            className="form-control form-control-sm keep"
            name="soaInitialContactMethod"
            id="soaInitialContactMethod"
            onChange={props.onChange}
          >
            {methodOfContact.map((method) => {
              return (
                <option selected={method === props.formData.soaInitialContactMethod}>
                  {method}
                </option>
              );
            })}
          </select>
        </div>

        <div className="col-12 col-lg-4 mb-2">
          <label className="label">Appointment Date</label>
          <input
            type="date"
            className="keep form-control form-control-sm needsSlashes"
            name="soaAppointmentDate"
            value={props.formData.soaAppointmentDate}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaAppointmentDate && (
            <small className="text-danger">Field is required</small>
          )}
        </div>

        <div className="col-12  mb-2">
          <label className="label">Plans you will represent during meeting</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaDiscussedPlans"
            id="soaDiscussedPlans"
            value={props.formData.soaDiscussedPlans}
            onChange={props.onChange}
          />
        </div>
      </div>
    </>
  );
};
